import { render, staticRenderFns } from "./TabJustified.vue?vue&type=template&id=744191f0"
import script from "./TabJustified.vue?vue&type=script&lang=js"
export * from "./TabJustified.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports